import mapWidgetValues from "./map-widget-values";

export default function (
  values: any,
  method: string,
  originalValues: any = {}
): any {
  const result: any = {};
  result.id = values ? values.id : undefined;
  result.title = values ? values.title : undefined;
  result.owner = values.owner ? { id: values.owner } : undefined;
  result.group = values.group ? { id: values.group } : undefined;
  result.permissionOwner = values ? values.permissionOwner : undefined;
  result.permissionGroup = values ? values.permissionGroup : undefined;
  result.permissionOther = values ? values.permissionOther : undefined;
  result.publicAvailable = values ? values.publicAvailable : undefined;
  result.widgets = values.widgets
    ? values.widgets.map((v: any) => mapWidgetValues(v, method))
    : [];
  return result;
}
